module.exports = __webpack_public_path__ + "img/icon_5_93.a5514140.png";